/** Formatação em pt-BR usada em todo o painel. */

const numberFormat = new Intl.NumberFormat('pt-BR');
const currencyFormat = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const dateFormat = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });
const dateTimeFormat = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
});

export const fmtNumber = (value: number | null | undefined): string => numberFormat.format(Math.round(Number(value ?? 0)));

export const fmtDecimal = (value: number | null | undefined, digits = 1): string =>
  new Intl.NumberFormat('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(value ?? 0));

export const fmtMoney = (value: number | null | undefined): string => currencyFormat.format(Number(value ?? 0));

export const fmtPercent = (value: number | null | undefined, digits = 1): string =>
  `${fmtDecimal((Number(value ?? 0)) * 100, digits)}%`;

export function fmtDuration(seconds: number | null | undefined): string {
  const total = Math.max(0, Math.round(Number(seconds ?? 0)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number): string => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

export function fmtBytes(bytes: number | null | undefined): string {
  const value = Number(bytes ?? 0);
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${fmtDecimal(value / 1024, 1)} KB`;
  if (value < 1024 * 1024 * 1024) return `${fmtDecimal(value / 1024 / 1024, 1)} MB`;
  return `${fmtDecimal(value / 1024 / 1024 / 1024, 2)} GB`;
}

export const fmtDate = (iso: string): string => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : dateFormat.format(date);
};

export const fmtDateTime = (iso: string): string => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : dateTimeFormat.format(date);
};

export function relativeTime(iso: string): string {
  const date = new Date(iso).getTime();
  if (Number.isNaN(date)) return '—';
  const diff = Date.now() - date;
  const minutes = Math.round(diff / 60000);
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `há ${hours} h`;
  const days = Math.round(hours / 24);
  if (days < 30) return `há ${days} d`;
  return fmtDate(iso);
}

export const STATUS_LABEL: Record<string, string> = {
  draft: 'Rascunho',
  uploading: 'Enviando',
  processing: 'Processando',
  ready: 'Pronto',
  incompatible: 'Incompatível',
  failed: 'Falhou',
};

export const STATUS_TONE: Record<string, string> = {
  draft: 'muted',
  uploading: 'info',
  processing: 'info',
  ready: 'ok',
  incompatible: 'danger',
  failed: 'danger',
};

export const EVENT_LABEL: Record<string, string> = {
  player_loaded: 'Player carregado',
  video_impression: 'Impressão',
  video_started: 'Play',
  progress_25: '25% assistido',
  progress_50: '50% assistido',
  progress_75: '75% assistido',
  video_completed: 'Concluído',
  video_paused: 'Pausado',
  video_resumed: 'Retomado',
  video_replayed: 'Reassistido',
  cta_shown: 'CTA exibido',
  cta_clicked: 'CTA clicado',
  form_started: 'Formulário iniciado',
  lead_submitted: 'Lead enviado',
  checkout_clicked: 'Checkout aberto',
  purchase: 'Compra',
};
